module.exports = __webpack_public_path__ + "static/media/goalImage@3x.0b44e196.png";